import { jsxs as g, jsx as n } from "react/jsx-runtime";
import { u as P } from "./uniqueId-321287e8.mjs";
import l, { useEffect as ee } from "react";
import { useWindowDimensions as te } from "./useWindowDimensions.js";
import { B as re } from "./themes-5f0b3c3d.mjs";
import { TableContext as ne } from "./table.js";
import { Disclosures as le } from "./disclosure.js";
import { T as oe, a as ie, b as se, L as O, C as ce, c as me, M as ae, d as ue, i as R, p as k } from "./tableSearchView-b79fee3d.mjs";
import { T as be, a as i } from "./tableContainer-cf101627.mjs";
import "./index-6a632112.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./lineHeights-72d3110c.mjs";
import "./checkbox.js";
import "./checkmark-84b5274e.mjs";
import "./types-b577bf77.mjs";
import "./subtract-848336fd.mjs";
import "./accessibility.js";
import "./label-3b996c7d.mjs";
import "./tooltip.js";
import "./zIndices-d07533f3.mjs";
import "./getElementPosition-5026bb28.mjs";
import "./popupTip.js";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./iconButton.js";
import "./button.js";
import "./textStyles-42cab346.mjs";
import "./checkmarkFilled-c2b01ef1.mjs";
import "./informationFilled-05d57719.mjs";
import "./accordion.js";
import "./caretUp-e6db3a6f.mjs";
import "./superScript-393c70dc.mjs";
import "./dropdownMenu.js";
import "./textInput.js";
import "./helperText-698f3ed9.mjs";
import "./warningFilled-691cfde1.mjs";
import "./index-39f84169.mjs";
import "./radio.js";
import "./menu.js";
import "./moreVertical-dc2e97a2.mjs";
import "./index-c8707610.mjs";
import "./tslib.es6-59e1c9d8.mjs";
import "./index-98c703e1.mjs";
import "./_commonjsHelpers-d4512b9c.mjs";
import "./filter.js";
import "./chip.js";
import "./modalMixedStructure.modalWindow-3bb1e4ef.mjs";
import "react-dom";
import "./hTag-40b23797.mjs";
import "./badge.js";
import "./caretDown-8ff83493.mjs";
import "./pagination.js";
import "./caretLeft-980c1667.mjs";
import "./caretRight-e0ea6357.mjs";
import "./selectInput.js";
import "./cancelCloseFilled-b2127cb6.mjs";
import "./tags.js";
import "./screenReaderOnly.js";
import "./debounce.js";
const fe = ({
  headerValues: u = [],
  rowValues: a = [],
  paginationProp: r,
  isStickyColumnEnabled: L,
  isOptionProps: $,
  isCheckboxEnabled: _,
  disclosures: h,
  searchProp: y,
  filterProps: C,
  headerCheckboxProps: w,
  emptyTableMessage: D = "There is no data to display",
  isStatic: W
}) => {
  const { width: M } = te(), [E, B] = l.useState(1), {
    setShowOptionsEnabled: j,
    setShowCheckboxEnabled: v,
    setIsStickyColumnEnabled: G,
    assignCheckboxesDefaultValues: H,
    setAllCheckboxChecked: q,
    sortOrder: K
  } = l.useContext(ne), [b, N] = l.useState(
    []
  ), f = l.useRef([]), d = l.useRef(0), V = l.useRef(!1), [x, U] = l.useState(!1), [A, F] = l.useState(!1), [z, J] = l.useState(5);
  ee(() => {
    d.current = r?.itemsPerPage || 0;
  }, [r?.itemsPerPage]);
  const I = ({
    newTablePage: e,
    newUpdatedRowValues: t,
    sortOrderValue: o,
    comparator: T
  }) => {
    if (W) {
      f.current = t;
      const p = t;
      N(p.length === 0 ? [] : p);
    } else {
      let p = [];
      if (A) {
        const m = o ?? K;
        p = t.slice().sort((Y, Z) => {
          const s = Y.cellData[m.columnNumber]?.textValue ?? "", c = Z.cellData[m.columnNumber]?.textValue ?? "";
          return T ? T(s, c, m.value === "desc") : m.value === "asc" ? !isNaN(Number(s)) && !isNaN(Number(c)) ? Number(s) - Number(c) : R(s) && R(c) ? k(s) - k(c) : s.localeCompare(c) : !isNaN(Number(s)) && !isNaN(Number(c)) ? Number(c) - Number(s) : R(s) && R(c) ? k(c) - k(s) : c.localeCompare(s);
        });
      }
      if (r && r?.isPaginationEnabled && A) {
        f.current = p;
        const m = p.slice(
          (e - 1) * d.current,
          e * d.current
        );
        N(m.length === 0 ? [] : m);
      } else if (A)
        N(p);
      else if (r && r.isPaginationEnabled) {
        f.current = t;
        const m = t.slice(
          (e - 1) * d.current,
          e * d.current
        );
        N(m.length === 0 ? [] : m);
      } else
        N(t);
      e !== E && X(e);
    }
  };
  l.useEffect(() => {
    I({
      newUpdatedRowValues: (x || V.current) && b || a,
      newTablePage: (x || V.current) && E || E
    });
  }, [u, a, d, A]);
  const S = ({
    rowValues: e,
    sortOrderValue: t,
    filterOrSearchEnabled: o,
    comparator: T
  }) => {
    I({
      newUpdatedRowValues: e,
      newTablePage: o && 1 || E,
      sortOrderValue: t,
      comparator: T
    });
  };
  l.useEffect(() => {
    r?.tablePage && r.tablePage !== E && B(r?.tablePage);
  }, [r?.tablePage]), l.useEffect(() => {
    j(!!$?.isOptionsEnabled);
  }, [$?.isOptionsEnabled]), l.useEffect(() => {
    G(!!L);
  }, [L]), l.useEffect(() => {
    if (a.length) {
      const e = [];
      a.forEach((t) => {
        const o = w?.checkboxDefaultValue ?? t.checkboxDefaultValue ?? t.checkboxProps?.checkboxDefaultValue ?? 0;
        e.push({
          id: t.rowId,
          value: o
        });
      }), H(e), w?.checkboxDefaultValue && q(
        w?.checkboxDefaultValue,
        e
      );
    }
  }, [a, w?.checkboxDefaultValue]), l.useEffect(() => {
    v(!!_);
  }, [_]);
  const Q = l.useCallback(() => {
    J(
      r?.totalItems || f.current.length
    );
  }, [r?.totalItems, f.current.length]);
  l.useEffect(() => {
    Q();
  }, [r?.totalItems, f.current.length]);
  const X = (e) => {
    r?.setTablePage && r?.setTablePage(e), B(e);
  };
  return /* @__PURE__ */ g(be, { children: [
    y?.isSearchEnabled && /* @__PURE__ */ n(
      oe,
      {
        rowValues: x && b || a,
        setRowValues: (e) => {
          S({
            rowValues: e,
            filterOrSearchEnabled: !0
          });
        },
        setSearchEnabled: (e) => V.current = e,
        ...y
      }
    ),
    C?.isFilterEnabled && /* @__PURE__ */ n(
      ie,
      {
        variant: C.variant,
        sortFilterValues: C.sortFilterValues,
        headerValues: u,
        rowValues: V.current && b || a,
        setRowValues: (e) => {
          S({
            rowValues: e,
            filterOrSearchEnabled: !0
          });
        },
        onClearAll: C?.onClearAll,
        filterGroupLabel: C?.filterGroupLabel,
        setFilterEnabled: U,
        clearAllLabel: C?.clearAllLabel
      }
    ),
    M >= re.tabletMin ? /* @__PURE__ */ g(i, { isEmpty: !b.length, children: [
      /* @__PURE__ */ n(i.Head, { $checkboxProps: w, children: u.map((e, t) => /* @__PURE__ */ n(i.Header, { children: /* @__PURE__ */ g(
        i.CellContent,
        {
          contentAlignment: e?.contentAlignment || "center",
          children: [
            e.leadingComponents,
            e.textValue && /* @__PURE__ */ n(
              i.CellContentText,
              {
                contentAlignment: e?.contentAlignment || "center",
                children: e.textValue
              }
            ),
            e.trailingComponents,
            (e.isSortingEnabled || e.sortingProp?.isSortingEnabled) && /* @__PURE__ */ n(
              se,
              {
                rowValues: (V.current || x) && b || a,
                setRowValues: (o, T) => {
                  S({
                    rowValues: o,
                    sortOrderValue: T,
                    comparator: e.sortingProp?.comparator
                  });
                },
                columnNumber: t,
                onClick: e.sortingProp?.onClick,
                setSortingEnabled: F
              }
            )
          ]
        }
      ) }, `${e.id}_${P("table_head")}`)) }),
      /* @__PURE__ */ g(i.Body, { children: [
        b.map((e) => /* @__PURE__ */ n(
          i.Row,
          {
            id: e.rowId,
            $checkboxProps: e.checkboxProps,
            $dropDownComponent: e.DropDownComponent,
            children: e.cellData.map((t, o) => /* @__PURE__ */ n(
              i.Cell,
              {
                contentAlignment: u[o]?.contentAlignment || "center",
                id: t.id,
                children: /* @__PURE__ */ g(
                  i.CellWrapper,
                  {
                    contentAlignment: u[o]?.contentAlignment || "center",
                    children: [
                      t.leadingComponents && /* @__PURE__ */ n(O, { children: t.leadingComponents }),
                      /* @__PURE__ */ g(ce, { children: [
                        /* @__PURE__ */ g(
                          i.CellContent,
                          {
                            contentAlignment: u[o]?.contentAlignment || "center",
                            children: [
                              t.textValue && /* @__PURE__ */ n(
                                i.CellContentText,
                                {
                                  contentAlignment: u[o]?.contentAlignment || "center",
                                  children: t.textValue
                                }
                              ),
                              t.trailingComponents && !t.textValue && /* @__PURE__ */ n(O, { children: t.trailingComponents })
                            ]
                          }
                        ),
                        t.description && /* @__PURE__ */ n(i.CellDescription, { children: t.description })
                      ] }),
                      t.trailingComponents && t.textValue && /* @__PURE__ */ n(O, { children: t.trailingComponents })
                    ]
                  }
                )
              },
              `${t.id}_${P("table_cell")}`
            ))
          },
          `${e.rowId}_${P("table_row")}`
        )),
        b.length === 0 && /* @__PURE__ */ n(me, { isMobile: !1, children: D })
      ] })
    ] }) : /* @__PURE__ */ n(i.Container, { children: /* @__PURE__ */ n(
      ae,
      {
        setSortingEnabled: F,
        emptyTableMessage: D,
        headerValues: u,
        rowValues: b,
        setRowValues: (e, t, o) => {
          S({
            rowValues: e,
            sortOrderValue: t,
            comparator: o
          });
        },
        headerCheckboxProps: w
      }
    ) }),
    h && /* @__PURE__ */ n(
      le,
      {
        disclosureContent: h?.disclosureContent,
        id: h?.id,
        className: h?.className,
        disclosureTitleColor: h?.disclosureTitleColor,
        style: h?.style
      }
    ),
    r?.isPaginationEnabled && /* @__PURE__ */ n(
      ue,
      {
        totalItems: z,
        tablePage: E,
        initialItemsPerPage: r?.itemsPerPage,
        itemsPerPage: d.current,
        setItemsPerPage: (e) => {
          r && r?.setItemsPerPage && r.setItemsPerPage(e), d.current = e, I({
            newUpdatedRowValues: f.current,
            newTablePage: 1
          });
        },
        setTablePage: (e) => {
          I({
            newUpdatedRowValues: (V.current || x) && f.current || a,
            newTablePage: e
          }), r && r?.setTablePage && r.setTablePage(e);
        },
        showPerPageOption: r.showPerPageOption,
        perPageLabel: r?.perPageLabel,
        itemsLabel: r?.itemsLabel
      }
    )
  ] });
}, wt = fe;
export {
  wt as ComposedTable,
  fe as DataTable
};
